module.exports = __webpack_public_path__ + "static/media/Spotify_Icon_RGB_Black.b818d523.png";